<template>
  <jobs-consumer>
    <div class="tw-flex tw-flex-wrap tw-gap-2">
      <Button
        label="Sync"
        icon="pi pi-play"
        class="p-button-outlined p-button-sm"
        :disabled="isDisabled"
        :loading="sync.running"
        @click="startJob('sync')"
      />
      <Button
        label="Purge"
        icon="pi pi-trash"
        class="p-button-outlined p-button-sm"
        :disabled="isDisabled"
        :loading="purge.running"
        @click="startJob('purge')"
      />
      <Button
        label="Reconcile"
        icon="pi pi-refresh"
        class="p-button-outlined p-button-sm"
        :disabled="isDisabled"
        :loading="reconcile.running"
        @click="startJob('reconcile')"
      />
    </div>
    <Message v-if="isDisabled" severity="info" :closable="false" class="tw-mt-3">
      Starting a job is disabled while another job for the same source is running.
    </Message>
  </jobs-consumer>
</template>

<script>
import gql from 'graphql-tag'
import { areAnyJobsFromSourceRunning } from '../../lib/sync/utils/jobs'

export default {
  inject: ['jobsProvider'],
  props: {
    sourceName: String,
  },
  data() {
    return {
      sync: { running: false },
      purge: { running: false },
      reconcile: { running: false },
    }
  },
  methods: {
    startJob(type) {
      this[type].running = true
      const job = { sourceName: this.sourceName, type }
      const minWaitTimePromise = new Promise(resolve => setTimeout(resolve, 500))
      const mutationPromise = this.$apollo.mutate({
        mutation: gql`mutation ($job: JobInput!) {
          startJob(job: $job)
        }`,
        variables: { job },
      }).catch(error => {
        this.$toast.add({
          severity: 'error',
          summary: `Error starting ${type}`,
          detail: error.message,
          life: 6000,
        })
      })
      Promise.all([minWaitTimePromise, mutationPromise]).then(() => {
        this[type].running = false
      })
    },
  },
  computed: {
    isDisabled() {
      return areAnyJobsFromSourceRunning(this.jobsProvider.runningJobs, this.sourceName)
    },
  },
}
</script>
